import React from "react";
import ReactPaginate from "react-paginate";
import "./pagination.css";

const Pagination = ({ 
    pageCount,
	currentPage = 0,
	onPageChange 
}) => {
    return (
        <div className="pagination-container">
			<ReactPaginate
				previousLabel="Anterior"
				nextLabel="Próximo"
				breakLabel="..."
				pageCount={pageCount}
				marginPagesDisplayed={2}
				pageRangeDisplayed={2}
				onPageChange={onPageChange}
				forcePage={currentPage}
				containerClassName="pagination"
				activeClassName="active"
			/>
		</div>
    );
};

export default Pagination;